import { Button, CloseButton } from '@ui/shared/Button';
import * as React from 'react';
import styled from 'styled-components';
import { Level } from '../../../../data/types';
import { Column } from '../../../layout/Column';
import { Row } from '../../../layout/Row';
import { Card } from '../../../shared/card/Card';
import { CardBody } from '../../../shared/card/CardBody';
import { CardFooter } from '../../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../../shared/card/CardHeader';
import { Icon } from '../../../shared/Icon';
import {
  InnerPopupCard,
  PopupCardContent,
} from '../../../shared/popups/PopupCard';

interface IProps {
  level: Level;
  onClose: () => void;
}

export const ScoringDescription = (props: IProps): React.ReactElement => {
  const Container = props.level === 2 ? Card : InnerPopupCard;

  return (
    <Container onClose={props.onClose} size='small' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Scoring Description</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          <Column style={{ height: '100%', padding: '20px' }}>
            <Row style={{ height: '100%' }}>
              <DescriptionContainer>
                <Positive>
                  <Icon
                    name='north'
                    style={{ color: 'var(--color-dark-text)' }}
                  />
                </Positive>
                <Description>
                  {'>= 2 Standard Deviation improvement from the mean'}
                </Description>
              </DescriptionContainer>
              <DescriptionContainer>
                <Warning>
                  <Icon
                    name='north'
                    style={{ color: 'var(--color-dark-text)' }}
                  />
                </Warning>
                <Description>
                  {'>= 1 Standard Deviation improvement from the mean'}
                </Description>
              </DescriptionContainer>
              <DescriptionContainer>
                <Warning>
                  <Icon
                    name='south'
                    style={{ color: 'var(--color-dark-text)' }}
                  />
                </Warning>
                <Description>
                  {'>= 1 Standard Deviation regression from the mean'}
                </Description>
              </DescriptionContainer>
              <DescriptionContainer>
                <Negative>
                  <Icon
                    name='south'
                    style={{ color: 'var(--color-dark-text)' }}
                  />
                </Negative>
                <Description>
                  {'>= 2 Standard Deviation regression from the mean'}
                </Description>
              </DescriptionContainer>
            </Row>
            <Row>
              <div style={{ textAlign: 'center', padding: '30px' }}>
                ** For asymmetry metrics an improvement is considered to be a
                change that moves the athlete closer to 0
              </div>
            </Row>
          </Column>
        </CardBody>
        <CardFooter surface={8}></CardFooter>
      </PopupCardContent>
    </Container>
  );
};

const TrafficCircle = styled.div`
  height: 25px;
  width: 25px;
  color: var(--color-dark-text);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Positive = styled(TrafficCircle as any)`
  background-color: var(--color-material-500-green);
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Warning = styled(TrafficCircle as any)`
  background-color: var(--color-material-500-yellow);
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Negative = styled(TrafficCircle as any)`
  background-color: var(--color-material-500-red);
`;

const DescriptionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const Description = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 10px;
`;
